import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../business/Business.css';
import '../product/ProductIndexPage.css';
import CreateBusinessHeader from '../business/components/CreateBusinessHeader';
import CreateFooter from '../business/components/CreateFooter';
import {
  allDetailsColumnsForPicker,
  normalizeDetailsColumnOrder,
  writeDetailsColumnOrder,
} from './detailsColumns';

export default function OrdersDetailsIndexPage() {
  const navigate = useNavigate();

  const [columns, setColumns] = React.useState([]);
  const [selectedOrder, setSelectedOrder] = React.useState([]);
  const [submitError, setSubmitError] = React.useState(null);
  const [saving, setSaving] = React.useState(false);

  React.useEffect(() => {
    setColumns(allDetailsColumnsForPicker());
    setSelectedOrder([]);
  }, []);

  const getOrderNumber = React.useCallback(
    (columnId) => {
      const idx = selectedOrder.findIndex((id) => String(id) === String(columnId));
      return idx === -1 ? null : idx + 1;
    },
    [selectedOrder]
  );

  const toggleColumn = React.useCallback((columnId) => {
    setSelectedOrder((prev) => {
      const idx = prev.findIndex((id) => String(id) === String(columnId));
      if (idx === -1) return [...prev, columnId];
      return prev.filter((id) => String(id) !== String(columnId));
    });
  }, []);

  const selectedCount = selectedOrder.length;
  const isSubmitDisabled = saving || selectedCount === 0;

  function handleSubmit() {
    setSubmitError(null);
    setSaving(true);
    try {
      const nextOrder = normalizeDetailsColumnOrder(selectedOrder);
      if (nextOrder.length === 0) {
        setSubmitError('Нет колонок для сохранения');
        return;
      }
      writeDetailsColumnOrder(nextOrder);
      navigate(-1);
    } catch (_) {
      setSubmitError('Не удалось сохранить порядок');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="shop-create-root product-index-page-root">
      <div className="shop-create-mobile">
        <CreateBusinessHeader
          title="Порядок колонок"
          subtitle="Нажимайте на колонки в нужном порядке. Невыбранные колонки скрываются в таблице."
          onBack={() => navigate(-1)}
          backClassName="product-index-page-backButton"
        />

        <main className="shop-create-content">
          {submitError ? (
            <section className="shop-create-section shop-create-sectionError">
              <div className="shop-create-label">Ошибка</div>
              <div className="shop-create-help shop-create-helpTight">{submitError}</div>
            </section>
          ) : null}

          <section className="shop-create-section">
            <div className="product-index-page-listHeader">
              <div className="shop-create-label product-index-page-listTitle">Колонки</div>
              <div className="shop-create-help shop-create-helpTight">
                {selectedCount > 0
                  ? `Выбрано: ${selectedCount} из ${columns.length}`
                  : `${columns.length} колонок`}
              </div>
            </div>

            <div className="product-index-page-list">
              {columns.length === 0 ? (
                <div className="shop-create-help">Колонки не найдены.</div>
              ) : (
                columns.map((column) => {
                  const orderNumber = getOrderNumber(column.id);
                  const isSelected = orderNumber != null;

                  return (
                    <button
                      key={column.id}
                      type="button"
                      className={`product-index-page-item product-index-page-item--textOnly${isSelected ? ' product-index-page-item--selected' : ''}`}
                      onClick={() => toggleColumn(column.id)}
                      aria-pressed={isSelected}
                      aria-label={
                        isSelected
                          ? `${column.label}, порядок ${orderNumber}. Нажмите, чтобы снять`
                          : `${column.label}. Нажмите, чтобы выбрать`
                      }
                    >
                      <div className="product-index-page-main">
                        <div className="product-index-page-name">{column.label}</div>
                      </div>

                      <div
                        className={`product-index-page-orderBadge${isSelected ? ' product-index-page-orderBadge--filled' : ''}`}
                        aria-hidden="true"
                      >
                        {isSelected ? orderNumber : ''}
                      </div>
                    </button>
                  );
                })
              )}
            </div>
          </section>
        </main>

        <CreateFooter
          disabled={isSubmitDisabled}
          label={saving ? 'Сохранение…' : 'Сохранить порядок'}
          onCreate={handleSubmit}
        />
      </div>
    </div>
  );
}
